import React from 'react';
import PropTypes from 'prop-types';
import LocationCardFulfillmentMethod from 'locations/components/LocationCardFulfillmentMethod';
import { fulfillmentOptions } from 'cart/constants/fulfillmentOptions';
import LocationCardFulfillmentTypeGridItem from 'locations/ui_components/LocationCardFulfillmentTypeGridItem';
import Typography from '@material-ui/core/Typography';
import { getFormattedDayOfWeek } from 'base/utils/dates';

export const NOT_ACCEPTING_ORDERS_INFORMATION_TEXT =
  'No online dine-in ordering is offered for this location';

/**
 * Renders available fulfillment options(CTA) and availability for dine-in ordering.
 *
 * @param isAcceptingDineInOrders
 * @param isAsapDineInCurrentlyAvailable
 * @param beginOrder
 * @param id
 * @param openDisplayDineInHours
 * @param firstAvailableDineInDateOption
 * @returns {*} React functional component
 * @constructor
 */
const LocationCardDineInFulfillmentMethods = ({
  isAcceptingDineInOrders,
  isAsapDineInCurrentlyAvailable,
  beginOrder,
  id,
  openDisplayDineInHours,
  firstAvailableDineInDateOption
}) => (
  <React.Fragment>
    {isAcceptingDineInOrders && (
      <LocationCardFulfillmentMethod
        isFullWidth
        buttonLabel={
          isAsapDineInCurrentlyAvailable ? 'Dine-In' : 'Dine-In Later'
        }
        handleButtonClick={() => beginOrder(fulfillmentOptions.DINE_IN)}
        disableButton={!isAsapDineInCurrentlyAvailable}
        hoursLabel={
          isAsapDineInCurrentlyAvailable
            ? "Today's Dine-In Hours"
            : `Next Dine-In ${getFormattedDayOfWeek(
                firstAvailableDineInDateOption
              )}`
        }
        hours={openDisplayDineInHours}
        hoursType={fulfillmentOptions.DINE_IN}
        buttonDataTestId={`location-${id}-dine-in-button`}
        hoursDataTestId={`location-${id}-dine-in-hours`}
      />
    )}
    {!isAcceptingDineInOrders && (
      <LocationCardFulfillmentTypeGridItem>
        <Typography>{NOT_ACCEPTING_ORDERS_INFORMATION_TEXT}</Typography>
      </LocationCardFulfillmentTypeGridItem>
    )}
  </React.Fragment>
);

LocationCardDineInFulfillmentMethods.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  firstAvailableDineInDateOption: PropTypes.string,
  isAcceptingDineInOrders: PropTypes.bool,
  isAsapDineInCurrentlyAvailable: PropTypes.bool,
  openDisplayDineInHours: PropTypes.object
};

LocationCardDineInFulfillmentMethods.defaultProps = {
  firstAvailableDineInDateOption: '',
  isAcceptingDineInOrders: true,
  isAsapDineInCurrentlyAvailable: true,
  openDisplayDineInHours: {}
};

export default LocationCardDineInFulfillmentMethods;
